// @ts-ignore
// prettier-ignore
import { Modal,  Button,  connectModal,  TextInput, 
// @ts-ignore
  RequiredFieldIndicator} from '@gsa/afp-component-library';
import './OptionsSaveModal.scss';
import { useState } from 'react';

const dataTestIdPrefix = 'options-save-modal';

function OptionsSaveModal({ onClose, onSave }) {
  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState('');

  const onChangeComment = (event) => {
    const { value } = event?.target;
    setComment(value);
    if (value.trim().length) {
      setCommentError('');
    }
  };

  const closeModal = () => {
    onClose();
  };

  const Actions = ({ onCancel, onSave }) => {
    return (
      <footer data-testid={`${dataTestIdPrefix}-footer`}>
        <div className="grid-row flex-row flex-align-center grid-gap-lg">
          <Button
            type="button"
            variant="unstyled"
            onClick={onCancel}
            data-testid={`${dataTestIdPrefix}-cancel-btn`}
            label="Cancel"
          />
          <Button
            type="button"
            variant="primary"
            onClick={onSave}
            data-testid={`${dataTestIdPrefix}-save-btn`}
            label="Confirm and return to review summary"
            leftIcon={{ name: 'check', type: 'custom' }}
          />
        </div>
      </footer>
    );
  };

  // const onChangeStatus = (event) => {
  //   const { value } = event?.target;
  //   setStatus(value);
  // };

  const handleOnSave = () => {
    if (comment.trim().length < 1) {
      setCommentError('This field is required');
    } else {
      onSave(comment.trim());
    }
  };

  return (
    <Modal
      title={
        <>Confirm changes.</>
      }
      variant="medium"
      onClose={closeModal}
      actions={<Actions onCancel={closeModal} onSave={handleOnSave} />}
      className="options-save-modal"
    >
      <div className="modal-message usa-label">
        Are you sure you want to save these changes to the selected options?
      </div>
      <div className="comment-section">
        <TextInput
          id="place-order-modal-comment"
          type="textarea"
          maxLength={500}
          errorMessage={commentError}
          placeholder="Type comment here..."
          value={comment}
          onChange={onChangeComment}
          data-testid="place-order-modal-comment"
          characterLimit={500}
          className="options-save-textarea"
          label={
            <>
              Provide reason for changes <RequiredFieldIndicator />
            </>
          }
        />
      </div>
    </Modal>
  );
}

export default connectModal(OptionsSaveModal);
